import './checkout_fields.css';

export interface ObservationFieldCopy {
  readonly label: string;
  readonly placeholder: string;
}

export interface ObservationFieldProps {
  value: string;
  maxLength: number;
  onChange: (v: string) => void;
  copy: ObservationFieldCopy;
  /** Texto fora da regra (um valor legado acima do `maxLength`): o host diz o motivo. */
  invalid?: boolean;
  /** O id do textarea. Único na página: o card 1-Click pode estar na conversa
   *  junto da tela cheia e de outros cards, cada um com o seu campo. */
  id?: string;
}

/** Textarea da observação pro aprovador. O Figma (405-5518) tira o sufixo
 *  "Opcional" e o hint de compartilhamento — o label e o placeholder já dizem
 *  tudo. */
export function ObservationField({
  value,
  maxLength,
  onChange,
  copy,
  invalid = false,
  id = 'pc-observation',
}: Readonly<ObservationFieldProps>) {
  return (
    <div className="cpa-obs-field">
      <label className="cpa-obs-label" htmlFor={id}>
        {copy.label}
      </label>
      <textarea
        id={id}
        className="cpa-obs-textarea"
        value={value}
        maxLength={maxLength}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        aria-label={copy.label}
        aria-invalid={invalid || undefined}
        placeholder={copy.placeholder}
      />
    </div>
  );
}
